<template>
  <NewSecretGeneratedModal
    v-if="createdWebhookId"
    :webhook-id="createdWebhookId"
    @closed="openCreatedWebhook"
  />
  <WebhookConfigModal
    v-else
    :initial-event-types="initialEventTypes"
    @webhook-created="handleWebhookCreated"
    @closed="handleConfigClosed"
  />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

// TODO: move these into pages/api/components once temp_api_controls is removed
import NewSecretGeneratedModal from '@/components/integrations/NewSecretGeneratedModal.vue';
import WebhookConfigModal from '@/components/integrations/WebhookConfigModal.vue';

import { useFeatureFlagStore } from '@/stores';
import type { WebhookEventType } from '@/types/webhooks';

import useApiRoutes from '../useApiRoutes';

const emit = defineEmits<{
  closed: [];
}>();

useHead({ title: 'Create Webhook - Webhooks - API - Crossbeam' });

const createdWebhookId = ref<string | null>(null);

const { openDetail } = useApiRoutes();
const route = useRoute();
const { hasFeatureFlag } = useFeatureFlagStore();

const hasGreenfieldDealWebhooks =
  hasFeatureFlag('temp_genpipe_greenfields') &&
  hasFeatureFlag('temp_greenfield_deal_webhooks');

const initialEventTypes: WebhookEventType[] =
  route.query.webhookSource && hasGreenfieldDealWebhooks
    ? ['partner_greenfield_deal_closed_won']
    : [];

function handleWebhookCreated({ webhookId }: { webhookId: string }) {
  createdWebhookId.value = webhookId;
}

function openCreatedWebhook() {
  if (!createdWebhookId.value) return;
  openDetail('webhooks', createdWebhookId.value, { replace: true });
}

/**
 * WebhookConfigModal closes itself after a successful create, so only treat
 * this as a cancel when no webhook came back.
 */
function handleConfigClosed() {
  if (!createdWebhookId.value) emit('closed');
}
</script>
